import React from 'react';
import Box from '@mui/material/Box';
import styles from 'components/podiatry/page.module.scss';
import { Typography } from '@mui/material';
import MetaTag from 'components/meta';
import useIncompleteTempoRedirect from 'hooks/useIncompleteTempoRedirect';

function CompletedReasonForVisit() {
  useIncompleteTempoRedirect(true);

  return (
    <>
      <MetaTag title="The submission has been successful." />
      <Box pb={1}>
        <Box
          minHeight="70vh"
          mt={2}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography fontSize="40px">Congratulations!</Typography>
          <p className={styles.titleTextSubText}>
            The submission has been successful.
          </p>
        </Box>
      </Box>
    </>
  );
}

export default CompletedReasonForVisit;
